export default __webpack_public_path__ + "static/media/OpenSans-LightItalic.92aa69d8.woff";